import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { StyledCard, StyledCardBody, StyledCardTitle } from "./style.module";

function AppCardItem(props) {
  const CardImg = props.cardImg ? props.cardImg : null;
  const displayButton = props.displayButton ? props.displayButton : false;
  return (
    <StyledCard
      style={{
        cardPaddingTop: props.paddingTop ? props.paddingTop : null,
        width: props.cardWidth ? props.cardWidth : null,
      }}
      className="Card"
    >
      {CardImg && <Card.Img variant="top" src={CardImg} />}
      <StyledCardBody className="Card.Body">
        <StyledCardTitle className="Card.Title">{props.title}</StyledCardTitle>
        <Card.Text>{props.text}</Card.Text>
        {displayButton && (
          <Button variant="dark" onClick={props.onClick}>
            {props.buttonText}
          </Button>
        )}
      </StyledCardBody>
    </StyledCard>
  );
}

export default AppCardItem;
